import { DB_API_BASE_URL } from 'config/env';

/**
 * Base URL for Hostinger `server/` PHP API (no trailing slash).
 * @param {string} path e.g. `api/tests/kh_alk.php`
 */
export function dbApiUrl(path) {
  const p = path.startsWith('/') ? path.slice(1) : path;
  if (DB_API_BASE_URL) {
    return `${DB_API_BASE_URL}/${p}`;
  }
  return `/server/${p}`;
}

export const DEFAULT_SENSOR = import.meta.env.VITE_APP_SENSOR_ID || 'reef-temp-1';

/** Log each Hostinger `/server/api/...` call in the browser console (dev always; prod if VITE_APP_DEBUG_API=1). */
export const isDbApiDebugEnabled =
  import.meta.env.DEV ||
  import.meta.env.VITE_APP_DEBUG_API === 'true' ||
  import.meta.env.VITE_APP_DEBUG_API === '1';

/**
 * `fetch` for DB API URLs — logs method + full URL when debug is on.
 * @param {string} url Full URL (use with `dbApiUrl('api/...')`)
 * @param {RequestInit} [init]
 */
export function fetchDbApi(url, init) {
  const method = (init && init.method) || 'GET';
  if (isDbApiDebugEnabled) {
    // eslint-disable-next-line no-console -- intentional debug aid for API routing
    console.info(`[server API] ${method}`, url);
  }
  return fetch(url, {
    ...init,
    // Always bypass HTTP cache for DB APIs so lists (GET) match fresh data after saves.
    cache: init?.cache ?? 'no-store'
  });
}
